module.exports = __webpack_public_path__ + "img/print_template_detail.23b04878.svg";